var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoentitymanual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2E72D2",
    id: "_Icon_-_Info",
    "data-name": "\\uD83D\\uDFE6 Icon - Info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Info_-_Line_-_24px",
    "data-name": "Info - Line - 24px",
    d: "M14,4A10,10,0,1,0,24,14,10.011,10.011,0,0,0,14,4Zm0,1.5A8.5,8.5,0,1,1,5.5,14,8.489,8.489,0,0,1,14,5.5ZM14,9a1,1,0,1,0,1,1A1,1,0,0,0,14,9Zm-.012,3.489a.75.75,0,0,0-.738.761v5.5a.75.75,0,1,0,1.5,0v-5.5a.75.75,0,0,0-.762-.761Z",
    transform: "translate(-4 -4)",
    fill: "#2E72D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoentitymanual);
export default __webpack_public_path__ + "static/media/infoentitymanual.74af033895f4ba5290292c27ad7988cc.svg";
export { ForwardRef as ReactComponent };